<template>
	<div>
		<div>
			<div style="display: flex; justify-content: space-between">
				<div>
					<el-form :inline="true" class="demo-form-inline" label-position="right" label-width="100px"
						:model="searcheForm">
						<el-form-item label="选择站点:">
							<el-select style="width: 85%" v-model="searcheForm.stationId" placeholder="请选择"
								@change="stationIdChange">
								<el-option v-for="item in stationIdOptions" :key="item.value" :label="item.label"
									:value="item.value"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="订单编号：">
							<el-input placeholder="请输入订单编号" clearable width="180px" v-model="searcheForm.orderNumber">
							</el-input>
						</el-form-item>

						<!-- <el-form-item label="小区名称：">
              <el-input
                placeholder="请输入小区名称"
                clearable
                width="180px"
                v-model="searcheForm.stationName"
              ></el-input>
            </el-form-item> -->
						<!-- <el-form-item label="订单金额：">
              <el-input placeholder="请输入订单金额" clearable width="180px" v-model="searcheForm.payAmount" ></el-input>
            </el-form-item> -->
						<el-form-item label="桩号：" label-width="300">
							<el-input placeholder="请输入桩号" clearable width="180px" v-model="searcheForm.equipmentCode">
							</el-input>
						</el-form-item>
						<el-form-item label="手机号：" label-width="300">
							<el-input placeholder="请输入手机号" clearable width="180px" v-model="searcheForm.phoneNum">
							</el-input>
						</el-form-item>
						<el-form-item label="充电卡：" label-width="300">
							<el-input placeholder="请输入充电卡号码" clearable width="180px" v-model="searcheForm.cardNum">
							</el-input>
						</el-form-item>
						<!--<el-form-item label="插座号：" label-width="300">
              <el-input placeholder="请输入插座号" clearable width="180px" v-model="searcheForm.connectorCode" ></el-input>
            </el-form-item> -->
						<el-form-item label="订单状态：" label-width="300">
							<el-select style="width: 100%" v-model="searcheForm.chargingStatus" clearable
								placeholder="请选择订单状态">
								<el-option v-for="item in payStatusList" :key="item.status" :label="item.label"
									:value="item.status"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="启动方式：" label-width="300">
							<el-select style="width: 100%" v-model="searcheForm.startType" clearable
								placeholder="请选择启动方式">
								<el-option v-for="item in startOptions" :key="item.key" :label="item.value"
									:value="item.key"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="选择区域">
							<el-cascader v-model="searcheForm.areaCodes" :options="areaOptions"
								:props="{ checkStrictly: true }" @change="handleAreaChange" clearable></el-cascader>
						</el-form-item>
						<el-form-item label="订单创建日期：" label-width="300">
							<!-- <el-input placeholder="请输入订单创建日期" clearable width="180px" v-model="searcheForm.createTime" ></el-input> -->
							<el-date-picker v-model="searcheForm.timeRange" placeholder="请订单创建日期" clearable
								type="daterange" change="timeChangeChange()"
								value-format="yyyy-MM-dd"></el-date-picker>
						</el-form-item>

						<el-button icon="el-icon-search" type="primary" @click="findOrderPage('search')">搜索</el-button>

						<el-button icon="el-icon-search" type="primary" @click="exportOrders('search')">导出订单</el-button>


						<el-button icon="el-icon-search" type="default" @click="clearForm">清空</el-button>
					</el-form>
				</div>
			</div>
		</div>
		<!-- 表格 start -->
		<div style="margin-top: 30px">
			<el-table :data="orderList" stripe border v-loading="loading" element-loading-text="正在加载..."
				element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
				style="width: 100%">
				<el-table-column type="selection" align="center" width="44"></el-table-column>
				<el-table-column prop="equipmentCode" label="充电桩编码" width="160" align="center" fixed="left">
				</el-table-column>
				<el-table-column prop="connectorCode" label="插座号" width="80" align="center" fixed="left">
					<template slot-scope="scope">
						<span v-if="
                scope.row.equipmentType == 2 && scope.row.connectorCode == '1'
              ">
							A 口
						</span>
						<span v-if="
                scope.row.equipmentType == 2 && scope.row.connectorCode == '2'
              ">
							B 口
						</span>
						<span v-if="scope.row.equipmentType == 1">
							{{ scope.row.connectorCode }} 号口
						</span>
					</template>
				</el-table-column>
				<el-table-column prop="orderNumber" label="订单编号" width="240" align="center" fixed="left">
				</el-table-column>
				<el-table-column prop="payStatus" label="订单状态" width="120" align="center">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.chargingStatus == 0" type='info'>等待支付后启动</el-tag>
						<el-tag v-if="scope.row.chargingStatus == 1" type="success">充电中</el-tag>
						<el-tag v-if="scope.row.chargingStatus == 2" type="">充电完成</el-tag>
						<el-tag v-if="scope.row.chargingStatus == 3" type="warning">充电失败</el-tag>
						<el-tag v-if="scope.row.chargingStatus == 4" type="error">充电暂停</el-tag>
					</template>
				</el-table-column>
				<!-- stationName -->
				<el-table-column prop="localOrderNumber" label="系统订单号" width="180" align="center"></el-table-column>
				<el-table-column prop="outTradeNo" label="支付交易号" width="180" align="center"></el-table-column>
				<el-table-column prop="stationName" label="小区名称" width="180" align="center"></el-table-column>
				<el-table-column prop="startTime" label="开始时间 " width="180" align="center"></el-table-column>
				<el-table-column prop="endTime" label="结束时间 " width="180" align="center"></el-table-column>
				<el-table-column prop="totalMoney" label="订单金额（元）" width="120" align="center"></el-table-column>
				<el-table-column prop="feeType" label="计费方式" width="120" align="center">
					<template slot-scope="scope">
						<el-tag type="primary" v-if="scope.row.feeType===1">按小时计费</el-tag>
						<el-tag type="success" v-if="scope.row.feeType===2">按电量计费</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="elecPrice" label="计费" width="200" align="center">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.feeType===1">{{scope.row.elecPrice}} 元/小时</el-tag>
						<el-tag v-if="scope.row.feeType===2">电费：{{scope.row.elecPrice}}
							元/度，服务费：{{scope.row.servicePrice}} 元/度，</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="totalElecAmount" label="累计电费（元）" width="120" align="center"></el-table-column>
				<el-table-column prop="totalServiceAmount" label="累计服务费（元）" width="120"
					align="center"></el-table-column>
				<el-table-column prop="totalAmount" label="累计总费用（元）" width="120" align="center"></el-table-column>


				<el-table-column prop="totalMinutes" label="设备计时（分） " width="120" align="center"></el-table-column>

				<el-table-column prop="totalQuantity" label="充电电量(瓦分)" width="120" align="center"></el-table-column>


				<el-table-column prop="nick" label="用户昵称" width="200" align="center"></el-table-column>
				<el-table-column prop="phone" label="支付人手机号" width="200" align="center"></el-table-column>
				<el-table-column prop="startType" label="启动方式" width="120" align="center" :formatter="formatStartType">
				</el-table-column>
				<el-table-column prop="startType" label="卡号" width="120" align="center">
					<template slot-scope="scope">
						<span v-if="scope.row.startType!=2">非刷卡启动</span>
						<span v-if="scope.row.startType==2">{{scope.row.cardNum}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="reason" label="结束方式" width="120" align="center" :formatter="formatEndMode">
				</el-table-column>
				<el-table-column prop="refundStatus" label="退费状态" width="120" align="center">
					<template slot-scope="scope">
						<span v-if="scope.row.refundStatus==0">无需退费</span>

						<span v-if="scope.row.refundStatus==1">有退款</span>
					</template>
				</el-table-column>
				<el-table-column prop="refundAmt" label="退费金额" width="120" align="center">
				</el-table-column>
				<el-table-column prop="refundTime" label="退费时间" width="120" align="center">
				</el-table-column>
				<el-table-column prop="remark" label="备注" width="400" align="center"></el-table-column>
				<el-table-column prop="createTime" label="订单创建时间" width="100" align="center"></el-table-column>
				<el-table-column fixed="right" label="操作" width="200" align="center">
					<template slot-scope="scope">
						<el-button @click="showEditEmpView(scope.row)">查看</el-button>
						<el-button @click="doRefund(scope.row)">发起退款</el-button>
						<!-- <el-button @click="deleteUser(scope.row)" type="danger">删除</el-button> -->
					</template>
				</el-table-column>
			</el-table>
			<div style="display: flex; justify-content: flex-end">
				<el-pagination background @current-change="currentChange" @size-change="sizeChange"
					layout="sizes, prev, pager, next, jumper, ->, total, slot" :total="total"></el-pagination>
			</div>
		</div>
		<!-- 表格 END -->
		<el-dialog :title="title" :visible.sync="dialogVisible" width="1000px">
			<div style="height: 40vh; overflow: auto">
				<el-form :model="orderForm" ref="orderDetail" label-position="right" label-width="120px">
					<el-col :span="12">
						<el-form-item label="订单编号：">
							<el-input clearable width="180px" disabled v-model="orderForm.orderNumber"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="系统编号：">
							<el-input clearable width="180px" disabled v-model="orderForm.localOrderNumber"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="用户名：">
							<el-input clearable width="180px" disabled v-model="orderForm.nick"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="手机号：">
							<el-input clearable width="180px" disabled v-model="orderForm.phone"></el-input>
						</el-form-item>
					</el-col>

					<el-col :span="12">
						<el-form-item label="桩编码：">
							<el-input clearable width="180px" disabled v-model="orderForm.equipmentCode"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="接口号：">
							<el-input clearable width="180px" disabled v-model="orderForm.connectorCode"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="开始时间：">
							<el-input clearable width="180px" disabled v-model="orderForm.startTime"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="结束时间：">
							<el-input clearable width="180px" disabled v-model="orderForm.endTime"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="卡号：">
							<el-input clearable width="180px" disabled v-model="orderForm.monthCardSn"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="订单金额：">
							<el-input clearable width="180px" disabled v-model="orderForm.amount"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="充电时长：">
							<el-input clearable width="180px" disabled v-model="orderForm.totalMinutes"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="充电电量：">
							<el-input clearable width="180px" disabled v-model="orderForm.totalQuantity"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="小区名称：">
							<el-input clearable width="180px" disabled v-model="orderForm.stationName"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="备注">
							<el-input type="textarea" clearable rows="4" disabled v-model="orderForm.remark"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12"></el-col>
					<el-col :span="12"></el-col>
					<el-col :span="12"></el-col>
					<el-col :span="12"></el-col>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="doOrderDetailUpdate">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		deleteRequest,
		putRequest,
		getRequest,
		postRequest,
	} from "../../utils/api";
	import {
		apiGetArea,
	} from "../charge/ChargeStation";
	import {
		apiListStations
	} from "../charge/charge-equipment";
	export default {
		name: "OrderList",
		data() {
			return {
				title: "", //模态窗口 标题
				searcheForm: {
					startTime: null,
					endTime: null
				}, //搜索
				orderList: [], //列表数据
				rolesOptions: [],
				areaOptions: [],
				loading: false,
				dialogVisible: false, // 是否显示 模态窗口
				total: 0,
				page: 1,
				size: 10,
				user: {},
				stationList: [],
				stationIdOptions: [],
				startOptions: [{
						key: 1,
						value: "线上"
					},
					{
						key: 2,
						value: "刷卡"
					},
					{
						key: 3,
						value: "投币"
					},
					{
						key: 4,
						value: "系统"
					},
				],
				payStatusList: [{
						status: 0,
						label: "未启动"
					},
					{
						status: 1,
						label: "充电中"
					},
					{
						status: 2,
						label: "已完成"
					},
					{
						status: 3,
						label: "充电失败"
					},
					{
						status: 4,
						label: "故障"
					},
				],
				endModeOptions: [{
						key: 0,
						value: '时间用尽'
					},
					{
						key: 1,
						value: '负载被拔'
					},
					{
						key: 2,
						value: '充满自停'
					},
					{
						key: 3,
						value: '故障自停'
					},
					{
						key: 4,
						value: '功率过载'
					},
					{
						key: 5,
						value: '退费停止'
					},
					{
						key: 6,
						value: '未接负载'
					},
					{
						key: 7,
						value: '充实过长'
					},
					{
						key: 8,
						value: '电量用尽'
					},
					{
						key: 9,
						value: '在线停止'
					},
				],
				orderForm: {},
				userForm: {
					name: [{
							required: true,
							message: "请输入姓名",
							trigger: "blur"
						},
						{
							min: 2,
							max: 15,
							message: "长度在 2 到 15 个字符",
							trigger: "blur",
						},
					],
					phone: [{
							required: true,
							message: "请输入手机号",
							trigger: "blur"
						},
						{
							min: 11,
							max: 11,
							message: "长度是 11  个字符",
							trigger: "blur"
						},
					],
					gender: [{
						required: true,
						message: "请选择性别",
						trigger: "change"
					}],
					address: [{
						required: true,
						message: "请填写地址",
						trigger: "blur"
					}],
					remark: [{
						required: true,
						message: "请填写备注",
						trigger: "blur"
					}],
				},
			};
		},
		mounted() {
			this.findOrderPage();
			this.listArea();
			this.initSelectStations();
			getRequest("/api/system/basic/permiss/").then((res) => {
				this.rolesOptions = res;
			});
		},
		methods: {
			clearForm() {
				this.searcheForm = {};
			},
			listArea() {
				apiGetArea().then(resp => {
					console.dir(resp)
					this.areaOptions = resp.data
				})
			},
			initSelectStations() {
				apiListStations({
					page: 1,
					size: 9999
				}).then((resp) => {
					if (resp.status == 200) {
						const data = resp.data;
						this.stationList = data.list;
						this.stationList.forEach((element) => {
							this.stationIdOptions.push({
								label: element.stationName,
								value: element.id,
							});
						});
					}
				});
			},
			stationIdChange(v) {
				console.log("U Selected " + v);
			},
			doRefund(row) {
				this.$confirm("此操作将费用退回客户, 操作后无法撤回，是否继续", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					}).then(() => {
						getRequest("/api/order/refund/" + row.id).then((resp) => {
							if (resp.status == 200) {
								Message.error({
									message: resp.msg
								});
							} else {
								Message.error({
									message: resp.msg
								});
							}
						});
					})
					.catch(() => {
						this.$message({
							type: "info",
							message: "已取消删除",
						});
					});
			},
			payStatus(row, column) {
				const status = row.chargingStatus;
				if (status === 0) {
					return "未启动";
				}
				if (status === 1) {
					return "充电中";
				}
				if (status === 2) {
					return "已完成";
				}
				if (status === 3) {
					return "充电失败";
				}
				if (status === 4) {
					return "故障";
				}
			},
			doOrderDetailUpdate() {
				this.dialogVisible = false;
			},
			//编辑用户按钮
			showEditEmpView(data) {
				this.title = "订单详情";
				this.orderForm = data;
				this.dialogVisible = true;
			},
			exportOrders() {
				let url = '/api/charge-statistics/export';
				if(this.searcheForm.timeRange===undefined  || this.searcheForm.timeRange.length!=2){
					this.$message({type:'error',message:'请选择订单创建时间'})
					return ;
				}
				// this.searcheForm.startTime = this.searcheForm.timeChange[0]+' 00:00:00';
				// this.searcheForm.endTime = this.searcheForm.timeChange[1]+' 23:59:59';
				let areaCodes = this.searcheForm.areaCodes;
				if(areaCodes==undefined  ||  areaCodes.length===0){
					this.$message({
						type:'error',
						message: '导出订单区域信息不能为空'
					});
					return ;
				}
				this.searcheForm.startTime = this.searcheForm.timeRange[0]+' 00:00:00';
				this.searcheForm.endTime = this.searcheForm.timeRange[1]+' 23:59:59';
				if(areaCodes.length>=1){
					this.searcheForm.provinceCode = this.searcheForm.areaCodes[0]
				}
				if(areaCodes.length>=2){
					this.searcheForm.cityCode = this.searcheForm.areaCodes[1]
				}
				if(areaCodes.length==3){
					this.searcheForm.areaCode = this.searcheForm.areaCodes[2]
				}
				postRequest(url, this.searcheForm).then(
					(resp) => {

						if (resp.status == 200) {
							let filename = resp.data.filename;
							document.location.href = "http://shhp.city/upload/download/" + filename;
						}
					}
				);
			},
			//添加用户 && 更新用户
			doAddUser() {
				let url;
				if (this.user.id) {
					url = putRequest(`/api/system/user/`, this.user);
				} else {
					url = postRequest(`/api/system/user/addUser`, this.user);
				}
				this.$refs["userForm"].validate((valid) => {
					if (valid) {
						url.then((resp) => {
							if (resp) {
								this.dialogVisible = false;
								this.findOrderPage();
							}
						});
					}
				});
			},
			// 页大小
			sizeChange(currentSize) {
				this.size = currentSize;
				this.findOrderPage();
			},
			// 选择页
			currentChange(currentPage) {
				this.page = currentPage;
				this.findOrderPage("advanced");
			},
			// 查询用户列表
			findOrderPage(type) {
				if (type === 'search') {
					this.page = 1;
				}
				this.loading = true;
				postRequest(
					`/api/order/?page=${this.page}&size=${this.size}`,
					this.searcheForm
				).then((resp) => {
					this.loading = false;
					if (resp) {
						this.orderList = resp.data.list;
						this.total = resp.data.total;
					}
				});
			},
			formatEndMode(row, col, cellvalue, index) {
				let _text = '';
				if (row.reason != undefined) {
					this.endModeOptions.forEach(e => {
						if (e.key == parseInt(row.reason)) {
							_text = e.value;
						}
					})
				}
				return _text;
			},
			formatStartType(row, col, cellvalue, index) {
				let _text = '';
				if (row.reason != undefined) {
					this.startOptions.forEach(e => {
						if (e.key == parseInt(row.startType)) {
							_text = e.value;
						}
					})
				}
				return _text;
			},
			timeChangeChange() {
				this.searcheForm.startTime = this.searcheForm.timeRange[0]+' 00:00:00';
				this.searcheForm.endTime = this.searcheForm.timeRange[1]+' 23:59:59';
			},
			handleAreaChange(val) {
				console.log('current area code =' + val)
			}
		},
	};
</script>

<style>
	/* 可以设置不同的进入和离开动画 */
	/* 设置持续时间和动画函数 */
	.slide-fade-enter-active {
		transition: all 0.8s ease;
	}

	.slide-fade-leave-active {
		transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
	}

	.slide-fade-enter,
	.slide-fade-leave-to

	/* .slide-fade-leave-active for below version 2.1.8 */
		{
		transform: translateX(10px);
		opacity: 0;
	}
</style>